/**
 * Narrow helpers for public Packaging / Product label verification paths.
 * Only recognizes /l/package/ and /l/product/ — not unrelated /l/* routes.
 */

/**
 * @param {string} pathname
 * @returns {"packaging" | "product" | null}
 */
export function resolvePublicLabelType(pathname) {
	const path = String(pathname ?? "")
	if (path.startsWith("/l/package/")) return "packaging"
	if (path.startsWith("/l/product/")) return "product"
	return null
}

/**
 * @param {string} pathname
 * @returns {boolean}
 */
export function isPublicLabelVerificationPath(pathname) {
	return resolvePublicLabelType(pathname) != null
}
